exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page_blocks_container[data-v-ec63f706],.previewComponent .page_image[data-v-ec63f706]{width:100%;height:100%}.previewComponent .page_image img[data-v-ec63f706]{max-height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec63f706","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Previewstock.vue
// module id = 125
// module chunks = 0